import { ProjectCategoryType } from "@/__generated__/graphql";
import { FolderOpenDot } from "lucide-react";
import SpeakerIcon from "@/assets/Speaker";
import TvIcon from "@/assets/Tv";
import FilmIcon from "@/assets/Film";
import { getProjectIconColor } from "@/theme/colors";
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "@/components/ui/tooltip";

export const ProjectIcon = ({
  category,
  className,
  color,
}: {
  category: ProjectCategoryType | null | undefined;
  className?: string;
  color?: string;
}) => {
  if (!color && category) color = getProjectIconColor(category);
  switch (category) {
    case ProjectCategoryType.Commercial:
      return (
        <Tooltip>
          <TooltipTrigger asChild>
            <SpeakerIcon className={className} color={color} />
          </TooltipTrigger>
          <TooltipContent>
            <p>Commercial</p>
          </TooltipContent>
        </Tooltip>
      );
    case ProjectCategoryType.Tv:
      return (
        <Tooltip>
          <TooltipTrigger asChild>
            <TvIcon className={className} color={color} />
          </TooltipTrigger>
          <TooltipContent>
            <p>TV Shows</p>
          </TooltipContent>
        </Tooltip>
      );
    case ProjectCategoryType.Film:
      return (
        <Tooltip>
          <TooltipTrigger asChild>
            <FilmIcon className={className} color={color} />
          </TooltipTrigger>
          <TooltipContent>
            <p>Motion Pictures</p>
          </TooltipContent>
        </Tooltip>
      );
    default:
      return (
        <Tooltip>
          <TooltipTrigger asChild>
            <FolderOpenDot className={className} style={{ color }} />
          </TooltipTrigger>
          <TooltipContent>
            <p>Uncategorized</p>
          </TooltipContent>
        </Tooltip>
      );
  }
};
